import { createSelector } from "reselect";
import { RootState } from "../../store/rootStore";

export interface ILiveAgentSelector {
  loyaltyLevel: number;
  email: string;
  id: string;
  auth: boolean;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

const selectUserData = (state: RootState) => state.user;
const selectAuthData = (state: RootState) => state.authorization;

export const liveAgentSelector = createSelector(
  selectUserData,
  selectAuthData,
  (user, authorization) => {
    const loyaltyLevel = user?.loyalty?.level;
    const email = user.contacts.email;
    const phone = user.contacts.phone;
    const id = user.id;
    const auth = authorization.auth;
    const firstName = user.personalInfo ? user.personalInfo.name : undefined;
    const lastName = user.personalInfo ? user.personalInfo.surname : undefined;

    return {
      loyaltyLevel,
      email,
      phone,
      id,
      auth,
      firstName,
      lastName,
    } as ILiveAgentSelector;
  }
);
